import { useState, useEffect } from 'react';

const usePosition = () => {
    const [position, setPosition] = useState({
        latitude: null,
        longitude: null,
        accuracy: null,
        timestamp: null
    });
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        if (!navigator.geolocation) {
            setError('Geolocation is not supported by your browser');
            setLoading(false);
            return;
        }

        const successHandler = (position) => {
            const { latitude, longitude, accuracy } = position.coords;
            setPosition({
                latitude,
                longitude,
                accuracy,
                timestamp: position.timestamp
            });
            setError(null);
            setLoading(false);
        };

        const errorHandler = (error) => {
            let errorMessage;
            switch (error.code) {
                case error.PERMISSION_DENIED:
                    errorMessage = 'User denied geolocation permission';
                    break;
                case error.POSITION_UNAVAILABLE:
                    errorMessage = 'Location information unavailable';
                    break;
                case error.TIMEOUT:
                    errorMessage = 'Location request timed out';
                    break;
                default:
                    errorMessage = 'An unknown error occurred';
            }
            setError(errorMessage);
            setLoading(false);
        };

        const options = {
            enableHighAccuracy: true,
            timeout: 5000,
            maximumAge: 0
        };

        // Get initial position
        navigator.geolocation.getCurrentPosition(successHandler, errorHandler, options);

        // Set up continuous watching
        const watchId = navigator.geolocation.watchPosition(
            successHandler,
            errorHandler,
            options
        );

        // Cleanup
        return () => navigator.geolocation.clearWatch(watchId);
    }, []);

    return { ...position, error, loading };
};


export default usePosition;
